var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.items && _vm.items.length
    ? _c(
        "div",
        { staticClass: "toast-container position-fixed top-0 end-0 p-3" },
        _vm._l(_vm.items, function (item, index) {
          return _c("Toast", _vm._b({ key: index }, "Toast", item, false))
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }